import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message = 'Cargando...', fullScreen = false }) => {
  const containerClass = fullScreen
    ? 'loading-spinner-fullscreen'
    : 'loading-spinner-container';

  return (
    <div className={containerClass}>
      <div className="loading-spinner-content">
        <div className="spinner-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <h3 className="loading-title">💒 Dani & Ana</h3>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
